const getCookie = (name: string): string | undefined => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift();
  }
};

const setCookie = (clickID: string, domain: string, duration: number): void => {
  const cookieName = 'rtkclickid-store';
  const cookieValue = clickID;
  const expirationTime = 86400 * duration * 1000;
  const date = new Date();
  date.setTime(date.getTime() + expirationTime);
  const expires = date.toUTCString();
  document.cookie = `${cookieName}=${cookieValue}; expires=${expires}; path=/; domain=${domain}`;
};

export const getClickIdCookie = (): string | undefined => {
  return getCookie('rtkclickid-store');
};

export const getPixelCookieParams = (): {
  rtkfbp: string | undefined;
  rtkfbc: string | undefined;
  rtkttclid: string | undefined;
} => {
  return {
    rtkfbp: getCookie('_fbp'),
    rtkfbc: getCookie('_fbc'),
    rtkttclid: getCookie('ttclid'),
  };
};

export const persistClickIdCookie = (
  clickID: string,
  clickIdCookie: string | undefined,
  firstClickAttribution: boolean,
  cookieDomain: string,
  cookieDuration: number,
): void => {
  if (!clickIdCookie || !firstClickAttribution) {
    setCookie(clickID, cookieDomain, cookieDuration);
  }
};

let rememberedClickID: string | null = null;

export const getSessionClickID = (): string | null => {
  try {
    return rememberedClickID ?? sessionStorage.getItem('rtkclickid');
  } catch {
    return rememberedClickID;
  }
};

export const persistSessionClickID = (clickID: string): void => {
  rememberedClickID = clickID;

  try {
    sessionStorage.setItem('rtkclickid', clickID);
  } catch {
    /* ignore */
  }
};
